module.exports = __webpack_public_path__ + "media/registration/webinars@3x-88d92c1f.png";